var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "korean-general-story" }, [
    _vm.activeIndex === 0
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(
                  this.$i18n("stories_korean_general_language_1_title")
                ),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  this.$i18n("stories_korean_general_language_1_text")
                ),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M240 124.999C248.837 124.999 256 132.162 256 140.999V164.999C256 173.499 249.371 180.452 241 180.968V194.342C241 197.905 236.691 199.69 234.172 197.17L218 180.999L137 180.998C128.163 180.998 121 173.835 121 164.998V140.998C121 132.161 128.163 124.998 137 124.998L240 124.999Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M200 157.998C203.795 154.835 204 150.07 204 143.998C204 147.498 204.205 153.835 208 156.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M209 151.998L212 151.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M212 143.998V161.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M216 143.998V162.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M194 143.998V162.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M197 152.998L194 152.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M140 157.998V161.998H153",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M152 143.998V156.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M156 149.998L152 149.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: {
                  cx: "142",
                  cy: "148.998",
                  r: "4",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M179 146.998L189 146.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M184 146.998L184 142.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: {
                  cx: "184",
                  cy: "153.998",
                  r: "4",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M160 144.998V152.998H168",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "167.5",
                  cy: "159.998",
                  rx: "5.5",
                  ry: "3",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M168 144.998H173",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M168 148.998H173",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M173 142.998V153.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M222 159.998H238",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M227 159.998L227 153.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M233 159.998V153.998",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "230",
                  cy: "149.498",
                  rx: "7",
                  ry: "4.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M57.5 119C80.4198 119 99 105.121 99 88C99 70.8792 80.4198 57 57.5 57C34.5802 57 16 70.8792 16 88C16 98.2756 22.6929 107.384 33 113.024V124.343C33 127.907 37.3086 129.691 39.8284 127.172L48.6986 118.301C51.5353 118.759 54.48 119 57.5 119Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M62 80H74C74.1667 81.3333 74.2 84.6 73 87",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M62 90C61.4477 90 61 90.4477 61 91C61 91.5523 61.4477 92 62 92V90ZM75 91H76V90H75V91ZM75 95V96C75.5523 96 76 95.5523 76 95H75ZM62 95V94C61.4477 94 61 94.4477 61 95H62ZM62 99H61V100H62V99ZM75 100C75.5523 100 76 99.5523 76 99C76 98.4477 75.5523 98 75 98V100ZM62 92H75V90H62V92ZM74 91V95H76V91H74ZM75 94H62V96H75V94ZM61 95V99H63V95H61ZM62 100H75V98H62V100Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M77 87H59",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M36 81H46",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M41 81L41 78",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M40 94V99H52",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M51 79V93",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M55 86H51",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "41.5",
                  cy: "88",
                  rx: "4.5",
                  ry: "3",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M131 117L131 104",
                  stroke: "#E2B4FF",
                  "stroke-width": "4",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M117 122L105 110",
                  stroke: "#E2B4FF",
                  "stroke-width": "4",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M111 135L99 135",
                  stroke: "#E2B4FF",
                  "stroke-width": "4",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 1
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(
                  this.$i18n("stories_korean_general_language_2_title")
                ),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  this.$i18n("stories_korean_general_language_2_text")
                ),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "257",
                viewBox: "0 0 272 257",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "60",
                  y: "14.5",
                  width: "152",
                  height: "228",
                  rx: "16",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M212 83.5V99.5H201C196.582 99.5 193 95.9183 193 91.5C193 87.0817 196.582 83.5 201 83.5H212Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M212 35.5V67.5H175C170.582 67.5 167 63.9183 167 59.5C167 55.0817 170.582 51.5 175 51.5H187C182.582 51.5 179 47.9183 179 43.5C179 39.0817 182.582 35.5 187 35.5H212Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M60 51.5V83.5H92C96.4183 83.5 100 79.9183 100 75.5C100 71.0817 96.4183 67.5 92 67.5H80C84.4183 67.5 88 63.9183 88 59.5C88 55.0817 84.4183 51.5 80 51.5H60Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M139 58.5L157 58.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M148 58.5V65.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M142 46.5H154V53.5H142V46.5Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M118 47.5V60.5C120.333 60.5 125.6 60.2 128 59",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M132 45.5V65.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 53.5H132",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 77.5V92M136 92L131 87M136 92L141 87",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M101 120.5V107.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M112 120.5V109.143C112 107.565 110.258 106.609 108.926 107.456L101 112.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 120.5V110.5C129 108.291 127.21 106.5 125.001 106.5C124.522 106.5 124.019 106.5 123.5 106.5C120.5 106.5 119 109.5 119 109.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 117.499L125.42 119.647C124.491 120.205 123.428 120.499 122.344 120.499V120.499C120.497 120.499 119 119.002 119 117.155V117.068C119 116.072 119.427 115.115 120.244 114.544C120.758 114.183 121.379 113.79 122 113.499C124.5 112.327 129 112.499 129 112.499",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 120.5V107.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M145 120.5V109.129C145 107.376 142.906 106.471 141.629 107.672L136 112.971",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M154 120.5V109.129C154 107.376 151.906 106.471 150.629 107.672L145 112.971",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M161 107.5V117.227C161 119.035 162.465 120.5 164.273 120.5V120.5C167.436 120.5 170 117.936 170 114.773V107.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M134.182 208.911C131.918 212.134 128.512 214.373 124.656 215.175C120.8 215.977 116.783 215.281 113.422 213.229",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M114 234.5H159",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M108.995 209.159C107.387 206.963 106.385 204.382 106.091 201.677",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M106.41 196.46C107.246 192.894 109.318 189.74 112.258 187.557C115.198 185.373 118.816 184.301 122.471 184.53",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M134.245 203.166C129.144 199.771 125.431 194.571 123.846 188.544C122.142 182.067 123.034 175.165 126.326 169.358C128.733 165.111 132.28 161.703 136.5 159.5C136.867 159.692 137.23 159.893 137.589 160.104C143.29 163.457 147.45 168.979 149.154 175.456C149.94 178.444 150.174 181.523 149.874 184.542",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 181.5L141 176.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M151 203.5L156 198.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M121 211.5L126 206.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 188L130.5 182.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M151 209.5L147 205.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M121 207.5L117 203.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M160.897 195.929C161.089 194.6 161.013 193.234 160.659 191.912C159.973 189.35 158.297 187.166 156 185.84C153.703 184.514 150.974 184.154 148.412 184.841C145.85 185.527 143.666 187.203 142.34 189.5C141.212 191.453 140.784 193.719 141.103 195.929C138.675 196.664 136.612 198.296 135.34 200.5C134.014 202.797 133.654 205.526 134.341 208.088C135.027 210.65 136.703 212.834 139 214.16C141.297 215.486 144.026 215.846 146.588 215.159C148.266 214.71 149.781 213.836 151 212.641C151.595 213.225 152.266 213.736 153 214.16C155.297 215.486 158.026 215.846 160.588 215.159C163.15 214.473 165.334 212.797 166.66 210.5C167.986 208.203 168.346 205.474 167.659 202.912C166.973 200.35 165.297 198.166 163 196.84C162.331 196.453 161.625 196.149 160.897 195.929Z",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 171.5L136 199.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M151 194.5L151 234.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M121 200.5L121 234.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 211.5L136 234.5",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 2
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(
                  this.$i18n("stories_korean_keyboard_1_title")
                ),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_korean_keyboard_1_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M45.6804 131.924V190C45.6804 194.418 49.2622 198 53.6804 198H189V199.999C189 204.418 185.418 207.999 181 207.999H43C38.5817 207.999 35 204.418 35 199.999V139.924C35 135.506 38.5817 131.924 43 131.924H45.6804Z",
                  fill: "#AC6ED1",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M225 175V123C225 118.052 220.94 114 216 114H55C50.0603 114 46 118.052 46 123V189C46 193.948 50.0603 198 55 198H199.5C201.157 198 202.5 196.657 202.5 195C202.5 193.343 201.157 192 199.5 192H56C53.7909 192 52 190.209 52 188V124C52 121.791 53.7909 120 56 120H215.024C217.224 120 219.008 121.767 219.013 123.966V167",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M83 138C83 140.209 81.2091 142 79 142H68C65.7909 142 64 140.209 64 138V136C64 133.791 65.7909 132 68 132H79C81.2091 132 83 133.791 83 136V138Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M83 157C83 159.209 81.2091 161 79 161H68C65.7909 161 64 159.209 64 157V156C64 153.791 65.7909 152 68 152H79C81.2091 152 83 153.791 83 156V157Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M83 176C83 178.209 81.2091 180 79 180H68C65.7909 180 64 178.209 64 176V175C64 172.791 65.7909 171 68 171H79C81.2091 171 83 172.791 83 175V176Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M115 138C115 140.209 113.209 142 111 142H99C96.7909 142 95 140.209 95 138V136C95 133.791 96.7909 132 99 132H111C113.209 132 115 133.791 115 136V138Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M115 157C115 159.209 113.209 161 111 161H99C96.7909 161 95 159.209 95 157V156C95 153.791 96.7909 152 99 152H111C113.209 152 115 153.791 115 156V157Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M155.75 171H99C96.7909 171 95 172.791 95 175V176C95 178.209 96.7909 180 99 180H172C174.209 180 176 178.209 176 176V175C176 172.791 174.209 171 172 171H165.875",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M145 138C145 140.209 143.209 142 141 142H131C128.791 142 127 140.209 127 138V136C127 133.791 128.791 132 131 132H141C143.209 132 145 133.791 145 136V138Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M145 157C145 159.209 143.209 161 141 161H131C128.791 161 127 159.209 127 157V156C127 153.791 128.791 152 131 152H141C143.209 152 145 153.791 145 156V157Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M176 138C176 140.209 174.209 142 172 142H161C158.791 142 157 140.209 157 138V136C157 133.791 158.791 132 161 132H172C174.209 132 176 133.791 176 136V138Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M176 157C176 159.209 174.209 161 172 161H161C158.791 161 157 159.209 157 157V156C157 153.791 158.791 152 161 152H172C174.209 152 176 153.791 176 156V157Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M207 138C207 140.209 205.209 142 203 142H192C189.791 142 188 140.209 188 138V136C188 133.791 189.791 132 192 132H203C205.209 132 207 133.791 207 136V138Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M207 157C207 159.209 205.209 161 203 161H192C189.791 161 188 159.209 188 157V156C188 153.791 189.791 152 192 152H203C205.209 152 207 153.791 207 156V157Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M207 176C207 178.209 205.209 180 203 180H192C189.791 180 188 178.209 188 176V175C188 172.791 189.791 171 192 171H203C205.209 171 207 172.791 207 175V176Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M229 175C229 177.209 227.209 179 225 179C222.791 179 221 177.209 221 175C221 172.791 222.791 171 225 171C227.209 171 229 172.791 229 175Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M112 58C112 53.5817 115.582 50 120 50H152C156.418 50 160 53.5817 160 58V90C160 94.4183 156.418 98 152 98H120C115.582 98 112 94.4183 112 90V58Z",
                  fill: "#AC6ED1",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M134 66V85",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M134 74H140",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 3
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(
                  this.$i18n("stories_korean_keyboard_2_title")
                ),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_korean_keyboard_2_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "257",
                viewBox: "0 0 272 257",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M149.248 42.0932C149.248 36.2449 154 31.5 159.868 31.5C165.735 31.5 170.487 36.2449 170.487 42.0932C170.487 44.1594 169.895 46.0848 168.872 47.7131C168.268 48.6738 168.456 49.9082 168.856 50.7453C169.241 51.5507 170.147 52.5969 171.481 52.3488C174.976 51.6988 178.442 50.8745 181.817 49.7232C183.959 48.9924 186.289 49.8721 187.175 51.7938C187.744 53.0288 188.274 54.2246 188.564 54.9935C189.122 56.4702 189.609 57.9718 190.028 59.5C190.452 61.0471 190.545 62.8154 191.21 64.2823C191.535 64.9998 192.11 65.5317 193.053 65.7996C193.799 66.0114 194.773 66.0346 195.552 65.5156C197.229 64.3987 199.241 63.748 201.407 63.748C207.255 63.748 212 68.5006 212 74.368C212 80.2353 207.255 84.9879 201.407 84.9879C199.341 84.9879 197.415 84.3958 195.787 83.372C195.218 83.0141 194.555 82.9439 193.984 83.0054C193.406 83.0678 192.825 83.2738 192.341 83.5879C191.717 83.9934 191.404 84.5719 191.229 85.0874C191.188 85.2075 191.153 85.332 191.122 85.4562C190.928 86.2284 190.818 87.0244 190.65 87.8029C190.195 89.9189 189.623 92.0131 188.935 94.0814C188.804 94.4737 188.669 94.8652 188.53 95.2555C188.433 95.5277 188.07 96.5471 187.599 97.6289C187.363 98.1704 187.106 98.7137 186.847 99.1799C186.58 99.663 186.347 99.9968 186.173 100.171C185.413 100.931 184.171 101.5 183.107 101.5H133.178C131.815 101.5 130.586 100.807 129.989 99.6748C128.009 95.9162 126.447 91.4853 125.442 86.5982C125.33 86.0488 125.102 85.4648 125.732 85.1663C125.95 85.0635 126.191 85.0045 126.407 84.9975C126.627 84.9903 126.762 85.0375 126.827 85.0788C128.779 86.3118 131.093 87.0254 133.57 87.0254C140.538 87.0254 146.19 81.3894 146.19 74.4322C146.19 67.475 140.538 61.839 133.57 61.839C130.993 61.839 128.593 62.611 126.594 63.9364C126.53 63.979 126.396 64.0292 126.176 64.0268C125.96 64.0244 125.717 63.9707 125.498 63.8726C124.965 63.6347 125.215 62.2138 125.215 62.2138C125.215 62.2138 125.369 61.4015 125.452 61C126.289 56.9413 127.512 53.1974 129.04 49.8924C129.88 48.0761 132.241 47.4128 134.341 48.3853C138.511 50.3153 143.318 51.7674 148.533 52.6148C149.867 52.8316 150.746 51.777 151.111 50.9637C151.49 50.1203 151.643 48.8895 151.015 47.9475C150.446 47.0924 149.997 46.1502 149.695 45.1449C149.404 44.1789 149.248 43.1546 149.248 42.0932Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M156 81.5L181 81.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M168 81.5V69.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M112.043 40.9419C112.001 40.8768 111.95 40.7405 111.953 40.5179C111.954 40.4285 111.962 40.3445 111.976 40.2647C112.097 39.6011 112.909 39.4127 113.572 39.5349C114.065 39.6257 114.623 39.7313 115 39.8108C118.969 40.6472 122.631 41.8627 125.866 43.3797C127.649 44.2156 128.311 46.5789 127.348 48.6884C125.445 52.8571 124.014 57.6632 123.178 62.877C122.966 64.2016 123.999 65.082 124.81 65.4511C125.646 65.8314 126.87 65.987 127.808 65.3537C129.459 64.2385 131.438 63.5898 133.568 63.5898C139.314 63.5898 144 68.3291 144 74.2097C144 80.0903 139.314 84.8296 133.568 84.8296C131.536 84.8296 129.642 84.2393 128.039 83.2171C127.082 82.6073 125.854 82.7991 125.025 83.2008C124.222 83.5898 123.198 84.4964 123.441 85.8205C123.996 88.8481 124.773 91.8607 125.819 94.774C126.356 96.2704 126.125 97.9352 125.35 99.2251C124.58 100.508 123.328 101.342 121.856 101.342H78.8136C76.7227 101.342 75 99.6147 75 97.4495V47.5204C75 46.1501 75.687 44.9223 76.7976 44.3288C80.2834 42.466 84.356 40.9737 88.8379 39.9677C88.9921 39.9331 89.1873 39.8913 89.3923 39.8484C90.1573 39.6882 91.2204 39.9672 91.2456 40.7484C91.2527 40.9708 91.2055 41.1084 91.1641 41.1748C90.9557 41.5094 90.7622 41.8546 90.5849 42.2095C89.7281 43.9235 89.2458 45.8622 89.2458 47.9125C89.2458 54.8669 94.7966 60.5324 101.678 60.5324C108.559 60.5324 114.11 54.8669 114.11 47.9125C114.11 45.3383 113.35 42.9404 112.043 40.9419Z",
                  fill: "#AC6ED1",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M90 71.5H107V84.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M148 210.5V218.667C148 224.097 143.597 228.5 138.167 228.5H98.8333C93.4025 228.5 89 224.097 89 218.667V179.333C89 173.903 93.4025 169.5 98.8333 169.5",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M166 181V200.667C166 206.097 161.597 210.5 156.167 210.5H116.833C111.403 210.5 107 206.097 107 200.667V195.833V161.333C107 155.903 111.403 151.5 116.833 151.5H156.167C161.597 151.5 166 155.903 166 161.333V166.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 172.5H144C144.333 174.167 144.6 179.1 143 185.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M135 181.5V190.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M126 190.5H147",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M159 139.5L159 126.5",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M179 157.5L191 157.5",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M173 144.5L185 132.5",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("v-button", {
                attrs: {
                  i18n: { id: "onboarding_experience_start_btn" },
                  filled: true,
                  color: "primary",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.startLearning.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }